<template>
  <dashboard-widget title="CASK AGING" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardCaskAging')"
                      @delete="$emit('delete','DashboardCaskAging')"
                      @close="$emit('close')">
    <div v-show="allTypes.length!==0" ref="chart"/>
    <div v-if="allTypes.length===0" class="mt-12 pa-12 text-center">No casks found</div>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardCaskAging',
  props: {
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      allTypes: [],
      chart: null,
			options: {chartArea:{height:'75%',width:'90%'},
                isStacked:true,
                height:this.zoomed?440:250,
                width:this.zoomed?480:270,
                fontSize:this.zoomed?12:10,
                vAxis:{title:"Number of casks",gridlines:{count:3},minorGridLines:{count:0},viewWindowMode:"maximized"},
                hAxis:{slantedText:false, showTextEvery:2, title:"Age (years)"},
                colors:['red','orange','green','blue','purple','magenta','cyan','brown'],
								legend:{ position: "none" , alignment:'center'}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.ColumnChart(this.$refs.chart);
        google.visualization.events.addListener(this.chart, 'select', () => {
          this.$router.push({name:'InventoryCasks'});
        });
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardCaskAging {
                                            caskCountByTypeAge {
                                              name,colour,count,years,siteId
                                            }
                                          }`, {});
      if (!results.error) {
        this.allTypes = results.data.caskCountByTypeAge;
        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      // Get types and first line
      const types = {};
      const row1 = ["Age"];
      let n = 0;      // maximum age
      this.options.colors = [];
      for (const line of this.allTypes) {
        if (line.years > n)
          n = line.years;
        if (types[line.name] == undefined) {
          types[line.name] = row1.length;
          row1.push(line.name);
          this.options.colors.push(line.colour);
        }
      }

      // Initialize empty data
      const data = [row1];
      if (this.allTypes.length > 0) {
        for (let i = 0; i <= n; i++) {
//          const row = [`< ${i+1}`];
          const row = [`${i}`];
          for (let j = row1.length; j > 1; j--)
            row.push(0);
          data.push(row);
        }
      }

      // Put in data
      for (const line of this.allTypes) {
        const row = data[line.years+1];
        row[types[line.name]] = line.count;
      }

      const dataTable = window.google.visualization.arrayToDataTable(data);

      const textColor = {color:this.darkMode?'#ffffff':'#3d3d3d'};
      this.options.hAxis.textStyle = textColor;
      this.options.hAxis.titleTextStyle = textColor;
      this.options.vAxis.baselineColor = this.darkMode?'#ffffff':'#3d3d3d';
      this.options.vAxis.titleTextStyle = textColor;
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(dataTable, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    }
  }
}
</script>